module.exports = __webpack_public_path__ + "static/img/anxunMobel23.b029d688.png";